import BreadCrumb from "Components/Common/BreadCrumb"
import { OrderPage } from "features/orders"
import { Container } from "reactstrap"

const Orders = () => {
  return (
    <div className="page-content">
      <Container fluid>
          <BreadCrumb title={"Orders"} pageTitle={"Modules"} />
          <OrderPage />
        </Container>
      
    </div>
  )
}
export default Orders